export const JOURNAL_OPTIONS = [
  {
    name: "Nature Methods",
    link: "https://journals.example.com/nature-methods",
    title: "Nature Methods",
    abstract: "A journal focused on innovative scientific methods and technologies.",
  },
  {
    name: "The Lancet",
    link: "https://journals.example.com/the-lancet",
    title: "The Lancet: Global Health",
    abstract: "A journal focused on global health research and healthcare outcomes.",
  },
  {
    name: "PLOS ONE",
    link: "https://journals.example.com/plos-one",
    title: "PLOS ONE",
    abstract: "A multidisciplinary journal publishing research across science and medicine.",
  },
];

export const STATUS_OPTIONS = [
  "PENDING",
  "SUBMITTED_TO_JOURNAL",
  "TECHNICAL_CHECK",
  "EDITOR_ASSIGNED",
  "UNDER_REVIEW",
  "REQUIRED_REVIEWS_COMPLETED",
  "DECISION_IN_PROCESS",
  "ACCEPTED",
  "REVISION",
  "REJECTED",
  "PRODUCTION_AND_PUBLICATION",
];

export const DEFAULT_STATUS = STATUS_OPTIONS[0];

export const STATUS_COLORS = {
  PENDING: { text: "text-gray-700", bg: "bg-gray-50" },
  SUBMITTED_TO_JOURNAL: { text: "text-blue-700", bg: "bg-blue-50" },
  TECHNICAL_CHECK: { text: "text-cyan-700", bg: "bg-cyan-50" },
  EDITOR_ASSIGNED: { text: "text-indigo-700", bg: "bg-indigo-50" },
  UNDER_REVIEW: { text: "text-yellow-700", bg: "bg-yellow-50" },
  REQUIRED_REVIEWS_COMPLETED: { text: "text-teal-700", bg: "bg-teal-50" },
  DECISION_IN_PROCESS: { text: "text-purple-700", bg: "bg-purple-50" },
  ACCEPTED: { text: "text-green-700", bg: "bg-green-50" },
  REVISION: { text: "text-orange-600", bg: "bg-orange-50" },
  REJECTED: { text: "text-red-600", bg: "bg-red-50" },
  PRODUCTION_AND_PUBLICATION: {
    text: "text-pink-700",
    bg: "bg-pink-50",
  },
};

const FALLBACK_STATUS_COLOR = { text: "text-gray-700", bg: "bg-gray-100" };

export const getStatusColor = (status) =>
  STATUS_COLORS[status] || FALLBACK_STATUS_COLOR;